import React from "react";
import styles from './LeadQualityScreen.module.css'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DataInsufficientImage from '../../Assets/Images/data-insufficient.svg'

interface LeadSummaryDataInsufficientComponentProps {
    leadHighlightText: string,
    infoBannerText: string,
    data: any
}

const LeadSummaryDataInsufficientComponent: React.FC<LeadSummaryDataInsufficientComponentProps> = ({ leadHighlightText, infoBannerText, data }) => {
    return (
        <div className={styles.LqscsCardBody}>
            <div className={`${styles.LqscsCardBodyLeft} ${styles['insufficientData']}`}>
                <img src={DataInsufficientImage} alt="data-insufficient-image" width={"100%"} />
            </div>
            <div className={styles.LqscsCardBodyRight}>
                <div className={styles.LqscsPercentageInfo}>
                    <div className={styles.LqscsPercentageData}>
                        <div className={`${styles.LqscsPercentageDataVal} ${styles['insufficientData']}`}>{data.thresholdMessage}</div>
                        <div className={styles.LqscsPercentageDataLabel}>for this analysis</div>
                    </div>
                </div>
                <div className={styles.LqscsHighlight}>{leadHighlightText}</div>
                <div className={`${styles.LqscsBanner} ${styles["moderate"]}`}>
                    <span className={`${styles.LqscsBannerIcon} ${styles["moderate"]}`}>
                        <InfoOutlinedIcon className={styles.infoIcon} />
                    </span>
                    {infoBannerText}
                </div>
            </div>
        </div>
    )
}


export default LeadSummaryDataInsufficientComponent